(function () {
  function swapToSecondImage(card) {
    // Encuentra el primer slideshow dentro del card (el de media)
    const slideshow = card.querySelector("slideshow-component");
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll("slideshow-slide");
    if (!slides || slides.length < 2) return;

    // Guardamos estado original una sola vez
    if (!card.__hcOriginalHidden) {
      card.__hcOriginalHidden = Array.from(slides).map(s => s.hasAttribute("hidden"));
    }

    // Mostrar 2do slide y ocultar el 1ro (solo si existen)
    slides.forEach((s, i) => {
      if (i === 1) s.removeAttribute("hidden");
      if (i === 0) s.setAttribute("hidden", "");
    });
  }

  function restoreOriginalSlides(card) {
    const slideshow = card.querySelector("slideshow-component");
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll("slideshow-slide");
    if (!slides || !card.__hcOriginalHidden) return;

    slides.forEach((s, i) => {
      if (card.__hcOriginalHidden[i]) s.setAttribute("hidden", "");
      else s.removeAttribute("hidden");
    });
  }

  function setMainImageFromUrl(card, url) {
    // Cambia el <img> visible dentro del card
    // (no dependemos de clases exactas, tomamos el primer img dentro del media)
    const media = card.querySelector(".product-media, .product-media-container, .card-gallery, slideshow-component");
    if (!media) return;

    const img = media.querySelector("img");
    if (!img) return;

    img.src = url;
    // Evita que el srcset "pise" el cambio
    img.removeAttribute("srcset");
  }

  function initCard(card) {
    // Hover: cambia a segunda imagen si existe
    card.addEventListener("mouseenter", () => swapToSecondImage(card));
    card.addEventListener("mouseleave", () => restoreOriginalSlides(card));

    // Click en miniaturas de variantes
    card.addEventListener("click", (e) => {
      const btn = e.target.closest(".hc-thumb");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const url = btn.getAttribute("data-image");
      if (!url) return;

      // Activo visual
      card.querySelectorAll(".hc-thumb").forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      // Cambia imagen
      setMainImageFromUrl(card, url);

      // Si el theme estaba usando slides, evitamos que vuelva a “segunda imagen” en hover
      // marcando el card como “fixed” (opcional)
      card.__hcLockImage = true;
    });
  }

  function boot(root = document) {
    root.querySelectorAll("product-card.product-card").forEach(initCard);
  }

  // Inicial
  document.addEventListener("DOMContentLoaded", () => boot());

  // Por si Shopify re-renderiza secciones (recommendations/ajax)
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();